var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomElectricityLightBulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 58,
    viewBox: "0 0 53 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    fx: "50%",
    fy: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "31.663%",
    stopColor: "#FFF",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 32.5,
    r: 26.5,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M25.836 39.953a6.561 6.561 0 01-4.404-2.376 6.419 6.419 0 01-1.392-4.752 7.037 7.037 0 011.07-3.006l.132-.238c.13-.237.261-.475.38-.724a19.11 19.11 0 001.869-5.109c.071-.344.13-.582.167-.748h5.712c.06.19.131.475.238.939v.237a21.19 21.19 0 001.083 3.267c.295.667.624 1.317.988 1.948a8.532 8.532 0 011.297 3.386 7.532 7.532 0 01-.607 3.612 6.394 6.394 0 01-6.533 3.564z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M29.108 23.996a28.042 28.042 0 00-.119-.496h-4.932c-.029.13-.058.262-.076.35a19.543 19.543 0 01-1.907 5.222c-.105.22-.193.386-.394.75l-.149.267a6.535 6.535 0 00-.995 2.791 5.918 5.918 0 001.283 4.38 6.061 6.061 0 004.068 2.195l.01.001a5.888 5.888 0 006.014-3.268 7.014 7.014 0 00.571-3.335 8.079 8.079 0 00-1.236-3.212 20.904 20.904 0 01-1.015-2.003 21.69 21.69 0 01-1.108-3.344l-.015-.118v-.18zM25.78 40.449h-.004.009-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M22 15h9v9h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M22.5 15.5h8v8h-8zM26.5 0v15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricityLightBulb);
export default __webpack_public_path__ + "static/media/RoomElectricityLightBulb.541e46e7aff04cb8cf424b1e877aff3b.svg";
export { ForwardRef as ReactComponent };